t = require('views/internal/teacup-with-helpers')('change_org_vis')

module.exports = t.renderable (enterprise, text) ->
  t.div ->
    t.ul ->
      t.li { class: t.classify('team-setting-restriction-group': true) }, ->
        t.ul '.pop-over-list.checkable.green-check', ->
          t.li { class: t.classify(active: enterprise.organizationPrefs.permissionLevel is undefined) }, ->
            t.a { href: '#', 'data-restriction': 'undefined' }, ->
              t.format 'let-team-admins-decide'
              t.span { class: 'sub-name' }, ->
                t.format 'team-admins-can-change'
          t.hr()
      t.li { class: t.classify('team-setting-restriction-group': true, disabled: enterprise.organizationPrefs.permissionLevel is undefined) }, ->
        t.ul '.pop-over-list', ->
          t.li ->
            t.a { href: '#', 'data-restriction': 'private' }, ->
              t.icon 'private'
              t.strong ->
                t.format 'private'
              if enterprise.organizationPrefs.permissionLevel == 'private'
                t.icon 'check'
              t.span '.sub-name', ->
                t.text text.privateText



// WEBPACK FOOTER //
// ./app/scripts/views/templates/ent_org_prefs_permission_level.coffee